import type { Dayjs } from 'dayjs';
import { apiTaxDateToDayjs, type TaxRuleApiDto } from './types';
import type { TaxBandRule } from 'app/pages/TaxManager/taxTypes';
import { taxApiBandToRule, type TaxProductNameLookup } from './taxBandMappers';

function countryIdFromTaxRuleDto(dto: TaxRuleApiDto): number | string {
  const iso = dto.countryIsoCode;
  if (iso != null && String(iso).trim() !== '') {
    return String(iso).trim();
  }
  const v = dto.countryId;
  if (v == null) return 0;
  if (typeof v === 'number') {
    return Number.isFinite(v) && v > 0 ? v : 0;
  }
  const s = String(v).trim();
  if (s === '') return 0;
  const n = Number(s);
  if (Number.isFinite(n) && n > 0 && String(n) === s) return n;
  return s;
}

export type LoadedTaxRuleState = {
  name: string;
  countryId: number | string;
  centreId: number;
  specificCentre: boolean;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  includeEndDate: boolean;
  isActive: boolean;
  bands: TaxBandRule[];
};

export function taxRuleDtoToLoadedState(dto: TaxRuleApiDto, names: TaxProductNameLookup): LoadedTaxRuleState {
  const startDate = apiTaxDateToDayjs(dto.startDate);
  const endDate = apiTaxDateToDayjs(dto.endDate);
  const centreId = dto.centreId != null ? Number(dto.centreId) : 0;
  const bands = (dto.bands ?? []).map((b) => taxApiBandToRule(b, names));
  return {
    name: dto.name ?? '',
    countryId: countryIdFromTaxRuleDto(dto),
    centreId,
    specificCentre: centreId > 0,
    startDate,
    endDate,
    includeEndDate: !!(endDate && endDate.isValid()),
    isActive: dto.isActive !== false,
    bands,
  };
}